// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fbf1f2ae","389":"06232f9d","453":"1862c5a7","455":"2c47d644","509":"99576423","977":"a29e7b19"}[chunkId] + ".chunk.js";
};